<div class="sidenav">
  @if (authenticationService.showNavigation()) {
    <div  class="sidenav__pages">
      <mat-accordion>
        @if (authenticationService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('DASHBOARD_VIEW', 'CONTRIBUTION_REPORT_VIEW', 'FORM_SUMMARY_REPORT', 'REPORT_BUILDER') | async) {
          <mat-expansion-panel class="sidenav__pages__page"
            >
            <mat-expansion-panel-header (mouseenter)="prefetchLookerSession()">
              <mat-panel-title>
                {{'Reports' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if ((permissionService.hasPermission('GRAFANA') | async) && showStandardLookerDashboards()) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/reporting/dashboard/11"
                (mouseenter)="prefetchLookerSession('11')"
                routerLinkActive="active">
                {{'Usage Retail' | translate}}
              </a>
            }
            @if ((permissionService.hasPermission('GRAFANA') | async) && showStandardLookerDashboards()) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/reporting/dashboard/15"
                (mouseenter)="prefetchLookerSession('15')"
                routerLinkActive="active">
                {{'Product Insight' | translate}}
              </a>
            }
            @if ((permissionService.hasPermission('GRAFANA') | async) && showStandardLookerDashboards()) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/reporting/dashboard/13"
                (mouseenter)="prefetchLookerSession('13')"
                routerLinkActive="active">
                {{'Customer Journey' | translate}}
              </a>
            }
            @if ((permissionService.hasPermission('GRAFANA') | async) && showBypLookerDashboards()) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/reporting/dashboard/27"
                (mouseenter)="prefetchLookerSession('27')"
                routerLinkActive="active">
                {{'BYP - Executive Dashboard' | translate}}
              </a>
            }
            @if ((permissionService.hasPermission('GRAFANA') | async) && showBypLookerDashboards()) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/reporting/dashboard/28"
                (mouseenter)="prefetchLookerSession('28')"
                routerLinkActive="active">
                {{'BYP - Interactions Dashboard' | translate}}
              </a>
            }
          </mat-expansion-panel>
        }
        @if (authenticationService.isNotAnAgent() && permissionService.hasPermission('USER_VIEW') | async) {
          <mat-expansion-panel class="sidenav__pages__page"
            >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'Users' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (permissionService.hasPermission('USER_VIEW') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/users"
                routerLinkActive="active">
                {{'Users' | translate}}
              </a>
            }
            @if (permissionService.hasPermission('USER_VIEW') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/users/roles"
                routerLinkActive="active">
                {{'Business Roles' | translate}}
              </a>
            }
            @if (canUpdatePermissions) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/permissions"
                routerLinkActive="active">
                {{'Permissions' | translate}}
              </a>
            }
          </mat-expansion-panel>
        }
        @if (authenticationService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('STORE_VIEW', 'CONTACT_VIEW', 'ACCOUNT_VIEW', 'SALES_GOALS_TYPE_VIEW') | async) {
          <mat-expansion-panel class="sidenav__pages__page"
            >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{labelingService.getStoresLabel() | async}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (permissionService.hasPermission('STORE_VIEW') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/stores"
                routerLinkActive="active">
                {{labelingService.getStoresLabel() | async}}
              </a>
            }
            @if (permissionService.hasPermission('ACCOUNT_VIEW') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/stores/accounts"
                routerLinkActive="active">
                {{labelingService.getAccountsLabel() | async}}
              </a>
            }
            @if (permissionService.hasPermission('STORE_DESIGNATION_VIEW') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/stores/designations"
                routerLinkActive="active">
                {{labelingService.getStoreDesignationsLabel() | async}}
              </a>
            }
            @if (permissionService.hasPermission('STORE_TYPE_VIEW') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/stores/types"
                routerLinkActive="active">
                {{labelingService.getStoreTypesLabel() | async}}
              </a>
            }
          </mat-expansion-panel>
        }
        @if (authenticationService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('DYNAMIC_FORM_CREATE', 'DYNAMIC_FORM_MODIFY', 'ADHOC_VISIT_VIEW', 'STORE_VISIT_VIEW') | async) {
          <mat-expansion-panel
            class="sidenav__pages__page"
            >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'Forms' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (permissionService.hasAtLeastOnePermission('DYNAMIC_FORM_CREATE', 'DYNAMIC_FORM_MODIFY') | async) {
              <a
                class="sidenav__nav-link"
                routerLink="/visits/adminForms"
                routerLinkActive="active">
                {{'Forms' | translate}}
              </a>
            } @else {
              @if (permissionService.hasAtLeastOnePermission( 'ADHOC_VISIT_EDIT', 'STORE_VISIT_EDIT') | async) {
                <a
                  class="sidenav__nav-link"
                  routerLink="/visits/userForms"
                  routerLinkActive="active">
                  {{'Forms' | translate}}
                </a>
              }
            }
            @if (permissionService.hasPermission('PHOTOS_VIEW') | async) {
              <a
                class="sidenav__nav-link"
                routerLink="/visits/photos"
                routerLinkActive="active">
                {{'Photos' | translate}}
              </a>
            }
            @if (permissionService.hasPermission('PHOTO_CATEGORIES_VIEW') | async) {
              <a
                class="sidenav__nav-link"
                routerLink="/visits/photo-categories"
                routerLinkActive="active">
                {{'Photo Categories' | translate}}
              </a>
            }
          </mat-expansion-panel>
        }
        @if (authenticationService.isNotAnAgent() &&  permissionService.hasAtLeastOnePermission('ADHOC_VISIT_VIEW', 'STORE_VISIT_VIEW', 'ACTIVE_VISIT_VIEW') | async) {
          <mat-expansion-panel
            class="sidenav__pages__page"
            >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'Visits' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (permissionService.hasPermission('ADHOC_VISIT_VIEW') | async) {
              @if (permissionService.hasPermission( 'STORE_VISIT_VIEW') | async) {
                <a
                  class="sidenav__nav-link"
                  routerLink="/visits/all-visits"
                  routerLinkActive="active">
                  {{'All Completed' | translate}}
                </a>
              }
            }
          </mat-expansion-panel>
        }
        @if (permissionService.hasPermission('VIBA_USER') | async) {
          <mat-expansion-panel class="sidenav__pages__page"
            >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'VIBA Agent' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (permissionService.hasPermission('VIBA_USER') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/viba/agent/agent-live"
                routerLinkActive="active">
                {{'Live' | translate}}
              </a>
            }
          </mat-expansion-panel>
        }
        @if (authenticationService.isNotAnAgent() && permissionService.hasPermission('VIBA_ADMIN') | async) {
          <mat-expansion-panel class="sidenav__pages__page"
            >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'VIBA Admin' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/viba/admin/agent-activity"
                routerLinkActive="active">
                {{'Agents' | translate}}
              </a>
            }
            @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
              <mat-expansion-panel
                [routerLinkActiveOptions]="{exact:false}"
                routerLinkActive #rla="routerLinkActive"
                [expanded]="rla.isActive"
                >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <a class="sidenav__nav-link"
                      routerLink="/viba/admin/dialog-flow/batches"
                      >
                      {{'Virtual Agent' | translate}}
                    </a>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <a [routerLinkActiveOptions]="{exact: false}"
                  class="sidenav__nav-link"
                  routerLink="/viba/admin/dialog-flow/agent-configurations"
                  routerLinkActive="active">
                  {{'Configurations' | translate}}
                </a>
                <a [routerLinkActiveOptions]="{exact: false}"
                  class="sidenav__nav-link"
                  routerLink="/viba/admin/dialog-flow/avatar"
                  routerLinkActive="active">
                  {{ 'Avatars' | translate }}
                </a>
              </mat-expansion-panel>
            }
            @if (permissionService.hasPermission('VIBA_SNOOP') | async) {
              <a
                [routerLinkActiveOptions]="{exact:  true}"
                class="sidenav__nav-link"
                routerLink="/viba/admin/agent-snooper"
                routerLinkActive="active">
                {{'Call Supervision' | translate}}
              </a>
            }
            @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/viba/admin/clients"
                routerLinkActive="active">
                {{'Clients' | translate}}
              </a>
            }
            @if (permissionService.hasAtLeastOnePermission('BRAND_VIEW', 'VIBA_ADMIN') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/viba/admin/brands"
                routerLinkActive="active">
                {{'Brands' | translate }}
              </a>
            }
            @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/viba/admin/projects"
                routerLinkActive="active">
                {{'Projects' | translate}}
              </a>
            }
            @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/viba/admin/devices"
                routerLinkActive="active">
                {{'Devices' | translate}}
              </a>
            }
            <mat-expansion-panel
              [routerLinkActiveOptions]="{exact:false}"
              routerLinkActive #rla="routerLinkActive"
              [expanded]="rla.isActive"
              >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
                    <a
                      class="sidenav__nav-link"
                      routerLink="/viba/admin/endpoints"
                      >
                      {{'Endpoints' | translate}}
                    </a>
                  }
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
                <a
                  [routerLinkActiveOptions]="{exact: false}"
                  class="sidenav__nav-link"
                  routerLink="/viba/admin/endpoints/qrcodes"
                  routerLinkActive="active">
                  {{'QR Codes' | translate}}
                </a>
              }
              @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
                <a
                  [routerLinkActiveOptions]="{exact: false}"
                  class="sidenav__nav-link"
                  routerLink="/viba/admin/endpoints/weblinks"
                  routerLinkActive="active">
                  {{'Weblinks' | translate}}
                </a>
              }
            </mat-expansion-panel>
            @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/viba/admin/content"
                routerLinkActive="active">
                {{'Content' | translate}}
              </a>
            }
            <mat-expansion-panel
              [routerLinkActiveOptions]="{exact:false}"
              routerLinkActive #rla="routerLinkActive"
              [expanded]="rla.isActive"
              >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
                    <a
                      class="sidenav__nav-link"
                      routerLink="/viba/admin/products">
                      {{'Products' | translate}}
                    </a>
                  }
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
                <a
                  [routerLinkActiveOptions]="{exact: false}"
                  class="sidenav__nav-link"
                  routerLink="/viba/admin/products/products"
                  routerLinkActive="active">
                  {{'Products' | translate}}
                </a>
              }
              @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
                <a
                  [routerLinkActiveOptions]="{exact: false}"
                  class="sidenav__nav-link"
                  routerLink="/viba/admin/products/product-categories"
                  routerLinkActive="active">
                  {{'Product Categories' | translate}}
                </a>
              }
              @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
                <a
                  [routerLinkActiveOptions]="{exact: false}"
                  class="sidenav__nav-link"
                  routerLink="/viba/admin/products/product-types"
                  routerLinkActive="active">
                  {{'Product Types' | translate}}
                </a>
              }
            </mat-expansion-panel>
            @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
              <a
                [routerLinkActiveOptions]="{exact: true}"
                class="sidenav__nav-link"
                routerLink="/viba/admin/product-scraper"
                routerLinkActive="active">
                {{'Product Scraper' | translate}}
              </a>
            }
            @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
              <mat-expansion-panel
                [routerLinkActiveOptions]="{exact:false}"
                routerLinkActive #rla="routerLinkActive"
                [expanded]="rla.isActive"
                >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <a class="sidenav__nav-link"
                      routerLink="/viba/admin/queues"
                      >
                      {{'Queues' | translate}}
                    </a>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <a [routerLinkActiveOptions]="{exact: true}"
                  class="sidenav__nav-link"
                  routerLink="/viba/admin/queues"
                routerLinkActive="active">
                  {{'Queues' | translate}}
                </a>
                <a [routerLinkActiveOptions]="{exact: true}"
                  class="sidenav__nav-link"
                  routerLink="/viba/admin/queues/incoming-calls"
                  routerLinkActive="active">
                  {{'Incoming Calls' | translate}}
                </a>
              </mat-expansion-panel>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  }

  @if (authenticationService.isNotAnAgent() && authenticationService.showNavigation()) {
    <form [formGroup]="organizationForm" novalidate
      class="sidenav__organization-switch">
      <mat-form-field>
        <mat-select formControlName="activeOrganization"
          [matTooltip]="'Active Organization' | translate"
          placeholder="">
          @for (organization of authenticationService.organizations; track organization) {
            <mat-option [value]="organization.id">
              {{organization.orgName}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  }
  @if (!authenticationService.isEmbeddedAgent  && authenticationService.showNavigation()) {
    <button class = "menuButton" mat-button
      [routerLinkActiveOptions]="{exact: true}"
      routerLink="/users/change-password"
      routerLinkActive="active">
      <mat-icon>published_with_changes</mat-icon>
      <span> {{'Change Password' | translate}}</span>
    </button>
  }
  @if (whatsNewMenuDisplay && authenticationService.showNavigation()&& authenticationService.showNavigation()) {
    <button class = "menuButton" mat-button (click)="viewWhatsNew()" id="whats-new">
      <mat-icon [svgIcon]="(whatsNewHighlighting ? 'bellBlackBadge' : 'bellBlack')"></mat-icon>
      <span> {{"What's New" | translate}}</span>
    </button>
  }
  @if (authenticationService.isNotAnAgent() && authenticationService.showNavigation()) {
    <button class = "menuButton" mat-button
      (click)="onCreateHelpdeskTicket()">
      <mat-icon>headset_mic</mat-icon>
      <span> {{'Create a Help Desk Ticket' | translate}}</span>
    </button>
  }
  @if (authenticationService.isLoggedIn && !authenticationService.isEmbeddedAgent) {
    <button class = "menuButton" mat-button (click)="logout()"
      id="logout">
      <mat-icon>input</mat-icon>
      <span> {{'Log Out' | translate}}</span>
    </button>
  }

  <app-switch-language centered="true"></app-switch-language>
</div>
